export default "__VITE_ASSET__Ck$NlOEx__"